// @ts-nocheck
/* eslint-disable */
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const GetSSO = new ReduxAsyncAction('SSO_GET');
GetSSO.registerRequest(function () {
  return dash_api.get('/v1/sso').then(({ data }) => data);
});

export const getSSO = GetSSO.request;
export const SSO_GET = GetSSO.constants;

const SaveSSO = new ReduxAsyncAction('SSO_SAVE');
SaveSSO.registerRequest(function (payload) {
  return dash_api.post('/v1/sso', payload).then(({ data }) => data);
});

SaveSSO.showProgressBar();
export const saveSSO = SaveSSO.request;
export const SSO_SAVE = SaveSSO.constants;

export const SSO_UPDATE = 'SSO_UPDATE';
export function updateSSO(payload) {
  return {
    type: SSO_UPDATE,
    data: payload,
  };
}
